import { Box, HStack, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Text, useDisclosure } from "@chakra-ui/react";
import React, { useRef } from "react";
export const AnswerCard = (props) => {
    const modal = useDisclosure();
    const containerRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(HStack, { w: "100%", alignItems: "center" },
            props.answer.image && React.createElement(Image, { src: props.answer.image, w: 12, h: 12, borderRadius: "sm", objectFit: "contain", _hover: { outline: "2px solid #eee" }, onClick: () => modal.onOpen() }),
            React.createElement(Box, null,
                React.createElement(Text, { color: "fg.emphasized", fontWeight: "medium", fontSize: "sm" }, props.answer.answer),
                React.createElement(Text, { color: "fg.muted", textStyle: "sm" }, props.answer.description))),
        React.createElement("div", { ref: containerRef }),
        React.createElement(Modal, { isOpen: modal.isOpen, onClose: modal.onClose, portalProps: { containerRef }, size: "xl" },
            React.createElement(ModalOverlay, null),
            React.createElement(ModalContent, null,
                React.createElement(ModalCloseButton, null),
                React.createElement(ModalBody, { mt: 12 }, props.answer.image && React.createElement(Image, { src: props.answer.image, w: "100%", h: "auto" }))))));
};
